import { createDateRangeParams } from 'apiv2/project-port-panel/utils'
import { api } from '../../api'

export const organizationCardsApi = api
  .enhanceEndpoints({
    addTagTypes: ['organizationCards', 'availableOrganizations'],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      getOrganizationCards: builder.query({
        providesTags: ['organizationCards'],
        query: ({ dateStart, dateEnd }) => {
          const params = createDateRangeParams({ dateStart, dateEnd })

          return {
            url: `/organization-cards`,
            method: 'GET',
            params,
          }
        },
      }),
      getAvailableOrganizations: builder.query({
        providesTags: ['availableOrganizations'],
        query: () => {
          return {
            url: `/organization-cards/available-organizations`,
            method: 'GET',
          }
        },
        transformResponse: (response) =>
          response?.data.map(({ id, name }) => ({
            id,
            value: name,
            label: name,
          })) || [],
      }),
      addOrganizationCard: builder.mutation({
        invalidatesTags: ['organizationCards', 'availableOrganizations'],
        query: ({ organizationId }) => {
          return {
            url: `/organization-cards`,
            method: 'POST',
            body: { organization_id: organizationId },
          }
        },
      }),
      deleteOrganizationCard: builder.mutation({
        invalidatesTags: ['organizationCards', 'availableOrganizations'],
        query: ({ organizationId }) => {
          return {
            url: `/organization-cards/${organizationId}`,
            method: 'DELETE',
          }
        },
      }),
    }),
  })

export const {
  useGetOrganizationCardsQuery,
  useGetAvailableOrganizationsQuery,
  useAddOrganizationCardMutation,
  useDeleteOrganizationCardMutation,
} = organizationCardsApi
